<div class="index-shell">
    <app-header [breadcrumbs]="['System settings', 'System admins']"
                [links]="['/settings/general-information', '/settings/system-admins']"
                mainHeading="System admins">

        <div headingButton>
            @if ((user()?.permissions?.permissions ?? []).includes('user.create')) {
                <button class="add-button" cll-icon-button (click)="addSystemAdmin()" title="Add user"
                        aria-label="Add user">
                    <cll-icon type="outlined">add</cll-icon>
                </button>
            }
        </div>
    </app-header>
    <div>
        <cll-horizontal-tabs
            [appearance]="'contained'"
            [tabItems]="tabItems"
            [currentTabId]="(currentTabId$ | async)!"
            (currentTabIdChange)="currentTabIdChange($event)" />
        <div class="search-container">
            <cll-form-field label="Type a keyword...">
                <cll-icon cllPrefix>search</cll-icon>
                <input [formControl]="searchControl"
                       cllFormInput
                       type="text">

                @if (searchControl.value) {
                    <button (click)="searchControl.reset()"
                            cll-icon-button
                            cllTooltip="Clear search query"
                            cllSuffix>
                        <cll-icon>clear</cll-icon>
                    </button>
                }
            </cll-form-field>
        </div>


        @if (pageResult(); as request) {
            @if (request.isLoading) {
                <cll-spinner />
            }

            @if (request.error; as error) {
                <app-error-panel [error]="error" />
            }

            @if (request.value; as page) {
                <table class="cll-table">
                    <thead>
                    <tr>
                        <th>Reference</th>
                        <th>Name</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                    </thead>

                    <tbody>
                        @if (page.data.length === 0) {
                            <tr>
                                <td colspan="6" class="no-data-row">
                                    <div class="no-data-wrapper">
                                        No users found.
                                    </div>
                                </td>
                            </tr>
                        } @else {
                            @for (users of page.data; track users.id) {
                                <tr [routerLink]="['/users/', users.id]"
                                    class="clickable">
                                    <td>{{ users.reference }}</td>
                                    <td>{{ getDisplayName(users.person) }}</td>
                                    <td>
                                        @if (users.status) {
                                            <cll-badge colour="success">Active</cll-badge>
                                        } @else {
                                            <cll-badge colour="error">Inactive</cll-badge>
                                        }
                                    </td>
                                    <td class="align-right">
                                        <button cll-icon-button
                                                [cllMenuTriggerFor]="menu"
                                                (click)="$event.stopPropagation()">
                                            <cll-icon>more_vert</cll-icon>
                                        </button>

                                        <ng-template #menu>
                                            <cll-menu>
                                                <button cllMenuItem
                                                        [routerLink]="['/users/', users.id]">
                                                    <cll-icon type="outlined">open_in_new</cll-icon>
                                                    View user
                                                </button>
                                                @if ((user()?.permissions?.permissions ?? []).includes('user.update')) {
                                                    <button cllMenuItem (click)="removeAdmin(users)">
                                                        <cll-icon type="outlined">clear</cll-icon>
                                                        Remove as system admin
                                                    </button>
                                                }
                                            </cll-menu>
                                        </ng-template>
                                    </td>
                                </tr>
                            }
                        }
                    </tbody>
                </table>
            }
        }
    </div>
    <app-pagination-card
        (page)="setPage($event)"
        [meta]="meta()"
    />
</div>
